<template>
    <div>
        <div style="margin-inline: 5px;">
            <p v-if="!temMercadoPago&&!temPagueNaEntrega" style="color: black;color:white;font-size: 0.8em;">Cadastre uma forma de recebimento ou configure para receber pelo mercado pago.</p>
            
            
            <div class="card" v-if="temMercadoPago&&temPagueNaEntrega">

                <div style="padding: 0px;" class="como-pagar-container">
                    <button 
                    :class="pagarPeloAppSelecionado ?  'selecionado' : 'nao-selecionado'" 
                    @click="onClickPaguePeloApp" 
                    >Pague pelo app</button>
                    <button 
                    :class="!pagarPeloAppSelecionado ?  'selecionado' : 'nao-selecionado'" 
                    @click="onClickPagueNaEntrega" 
                    >Pague n{{retirarNoLocal?"o balcão":"a entrega"}}</button>
                </div>
            </div>
            <div v-if="!pagarPeloAppSelecionado" class="card">
                <h2 style="color: black;">Meios de pagamento na entrega</h2>
                <!-- <p>{{ JSON.stringify(padrao) }}</p> -->
                <div v-if="padrao.length > 0">
                    <button :style="{ background :this.padraoAberto?'var(--cinza-claro)':'',borderRadius: '5px 5px 0 0'}" class="botao-pague-na-entrada" @click="abrirPagamento('padrao')">
                        <img class="icones" src="../../assets/icons/ic-dinheiro.png" alt="">
                        <span>Dinheiro</span>
                    </button>
                    <div class="container-opcoes-pagamento" v-if="padraoAberto" >
                        <div class="img-check" v-for="(tipo, index) in padrao" :key="index"  @click="selecionar(tipo.id)">
                            <img v-if="selecionado != tipo.id" src="../../assets/icons/ic-unchecked.png" alt="">
                            <img v-if="selecionado == tipo.id" src="../../assets/icons/ic-checked.png" alt="">
                            <button :class="selecionado == tipo.id ? 'li-selecionado' : 'li-nao-selecionado'">{{ tipo.nome }}</button>
                        </div>
                    </div>


                    <!-- troco -->
                    <div v-if="selecionado == 1 && padraoAberto" class="div-troco">
                        <!-- <p> Valor total: {{ valorTotalComVirgula }}</p> -->
                        <p>Troco para quanto?</p>
                        <div class="div-input-troco">
                            <p>R$</p>
                            <input type="number" style="flex: 1;" v-model="troco" @input="onChangedInput" :disabled="naoPrecisoDeTroco" placeholder="0,00">
                        </div>
                        <div v-if="!validouValorTroco" class="mensagem-troco-errado">
                            O valor do pagamento em dinheiro não pode ser <b>menor</b> do que o valor do pedido. 
                        </div>
                        <br>
                        
                        <div style="margin-left: 20px;" class="img-check" @click="precisoDeTroco">
                            <img v-if="!naoPrecisoDeTroco" src="../../assets/icons/ic-unchecked.png" alt="">
                            <img v-if="naoPrecisoDeTroco" src="../../assets/icons/ic-checked.png" alt="">
                            <p :class="naoPrecisoDeTroco ? 'li-selecionado' : 'li-nao-selecionado'" style="padding: 5px">Não preciso de troco</p>
                        </div>
                        <br>
                    </div>
                </div>

                <div v-if="credito.length > 0">
                    <button :style="{ background :this.creditoAberto?'var(--cinza-claro)':''}" class="botao-pague-na-entrada" @click="abrirPagamento('credito')">
                        <img class="icones" src="../../assets/icons/ic-cartao.png" alt="">
                        <span>Cartões de crédito</span>
                    </button>

                    <div class="container-opcoes-pagamento" v-if="creditoAberto">
                        <div class="img-check" v-for="(tipo, index) in credito" :key="index" @click="selecionar(tipo.id)">
                            <img v-if="selecionado != tipo.id" src="../../assets/icons/ic-unchecked.png" alt="">
                            <img v-if="selecionado == tipo.id" src="../../assets/icons/ic-checked.png" alt="">
                            <button :class="selecionado == tipo.id ? 'li-selecionado' : 'li-nao-selecionado'">{{ tipo.nome }}</button>
                        </div>
                    </div>
                </div>

                <div v-if="debito.length > 0">
                    <button :style="{ background :this.debitoAberto?'var(--cinza-claro)':'',borderRadius: '0 0 5px 5px'}" class="botao-pague-na-entrada" @click="abrirPagamento('debito')">
                        <img class="icones" src="../../assets/icons/ic-cartao-preto.png" alt="">
                        <span>Cartões de débito / vale refeição</span>
                    </button>
                    <div class="container-opcoes-pagamento" v-if="debitoAberto">
                        <div class="img-check" v-for="(tipo, index) in debito" :key="index" @click="selecionar(tipo.id)">
                            <img v-if="selecionado != tipo.id" src="../../assets/icons/ic-unchecked.png" alt="">
                            <img v-if="selecionado == tipo.id" src="../../assets/icons/ic-checked.png" alt="">
                            <button :class="selecionado == tipo.id ? 'li-selecionado' : 'li-nao-selecionado'">{{ tipo.nome }}</button>
                        </div>
                    </div>
                </div>
                <!-- botao enviar pedido -->
                <slot></slot>
            </div>
        </div>

    </div>
</template>

<script>
import ApiDelivery from '@/api/ApisDelivery'
// import { converterParaDinheiroString } from '@/utils/Dinheiro'

export default {


    name: "TipoPagamento",

    props: {
        valorTotalPedidoMaisTaxa: Number,
        retirarNoLocal:Boolean,
    },
    data() {
        return {
            pagarPeloAppSelecionado: this.$store.state.mp_public_key != null && (this.$store.state.mp_tem_pix || this.$store.state.mp_tem_cartao),
            temFormaDePagamentoCadastrada:true,
            credito: [],
            debito: [],
            padrao: [],
            selecionado: null,
            seleciouDinheiro: false,
            troco: "",
            naoPrecisoDeTroco: false,

            padraoAberto: false,
            creditoAberto: false,
            debitoAberto: false,



        }
    },

    computed: {
        //Verifica se tem Token Mercado Pago e tem Pix ou Cartao Mercado Pago ativo
        temMercadoPago(){
            return (this.$store.state.mp_public_key != null && (this.$store.state.mp_tem_pix || this.$store.state.mp_tem_cartao))
        },
        //Verifica se tem alguma forma de recebimento ativa para delivery
        temPagueNaEntrega(){
            return (this.padrao.length || this.credito.length || this.debito.length)
        },
        validouValorTroco() {
            if (this.naoPrecisoDeTroco) {
                return true
            }
            if (this.troco == "") {
                return true
            }
            if (this.troco >= this.valorTotalPedidoMaisTaxa) {
                return true
            }
            return false
        }
    },

    mounted() {
        this.buscarMetodosDePagamento()
    },

    watch: {
        retirarNoLocal() {
            // Limpar seleção quando muda o modo de entrega
            this.selecionado = null
            this.troco = ""
            this.naoPrecisoDeTroco = false
            this.padraoAberto = false
            this.creditoAberto = false
            this.debitoAberto = false
        }
    },

    methods: {
        onClickPaguePeloApp() {
            this.pagarPeloAppSelecionado = true
            this.enviarFinal()
            this.$emit("pagarPeloAppSelecionado", true)
        },
        onClickPagueNaEntrega() {
            this.pagarPeloAppSelecionado = false
            this.$emit("pagarPeloAppSelecionado", false)

            // assim que o usuario clica em "pague na entrega", vamos setar o meio de pagamento para nulo
            this.selecionado = null
            this.$emit("callback", null) 
        },
        buscarMetodosDePagamento() {
            ApiDelivery.buscarTiposDePagamento(this.$store.state.cnpj, this.$store.state.numeroEmpresaFK)
            .then((res)=> {
                console.log('TIPOS DE RECEBIMENTO:')
                console.log(res)
                this.credito = res.credito
                this.debito = res.debito
                this.padrao = res.padrao
            })
            .catch((err)=> {alert(err)})
        },


        precisoDeTroco() {
            this.naoPrecisoDeTroco = !this.naoPrecisoDeTroco
        },

        abrirPagamento(tipo) {
            switch (tipo) {
                case "padrao":
                    this.padraoAberto = !this.padraoAberto
                    this.creditoAberto = false
                    this.debitoAberto = false
                    break;
                case "credito":
                    this.creditoAberto = !this.creditoAberto
                    this.debitoAberto = false
                    this.padraoAberto = false
                    break;
                case "debito":
                    this.debitoAberto = !this.debitoAberto
                    this.padraoAberto = false
                    this.creditoAberto = false
                    break;
                default:
                    break;
            }
        },

        selecionar(id) {
            this.selecionado = id
            if (this.selecionado == 0) {
                this.seleciouDinheiro = true
            } else {
                this.seleciouDinheiro = false
                this.troco = ""
            }
            this.enviarFinal()
        },

        /** toda vez que digitarmos o trocoi, vamos mandar no callback */
        onChangedInput() {
            this.enviarFinal()
        },

        enviarFinal() {
            if (this.pagarPeloAppSelecionado) {
                this.$emit("callback", { pagamentoId: "mp", trocoPara: null })
            } else {
                this.$emit("callback", { pagamentoId: this.selecionado, trocoPara: this.naoPrecisoDeTroco ? null : this.troco })
            }
        }

    }
}

</script>

<style scoped>

.como-pagar-container {
    display: flex;
    width: 100%;
    padding: 2px;
    margin: 2px;
    gap: 4px;
}
.como-pagar-container>.selecionado{
    background: var(--cor2);
    min-height: 50px;
    width: 50%;
    border-radius:3px;
}
.como-pagar-container>.nao-selecionado{
    color: var(--cor-texto);
    min-height: 50px;
    width: 50%;
    border-radius:3px;
}

.botao-pague-na-entrada{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    /* margin: 2px; */
    border: 0.5px solid var(--cinza-escuro);
    color: black;
    background: white;
    padding: 15px;
    /* border-radius:3px; */
    font-size: 1.2em;
}
.botao-pague-na-entrada>.icones{
    border: 1px solid var(--cinza-escuro);
    border-radius: 50%;
    padding: 5px;
}
.div-troco{
}
.div-troco>p{
    margin-bottom: 5px;
}
.div-input-troco{
    display: flex;
    align-items: center;
    max-width: 100%;
    justify-content: center;
    margin-inline: 20px;
}
.div-input-troco>p{
    margin-right: 15px;
    font-weight: bold;
    font-size: 1.2rem;
    color: green;
}

.container-opcoes-pagamento {
    margin-block: 5px;
    animation: container-opcoes-pagamento-anim 0.5s forwards;
    transform-origin: top center;
    margin-block: 15px;
    margin-left: 20px;
}
.container-opcoes-pagamento p {
    margin-block: 3px;
    padding: 5px;
    padding-inline: 8px;
    font-size: 0.9rem;
    border-radius: 5px;
    border: solid 1px black;
    text-align: start;
}

@keyframes container-opcoes-pagamento-anim {
    from { transform: scaleY(0%); }
      to { transform: scaleY(100%); }
}

h5 {
    margin: 0;
    margin-top: 35px;
    text-align: start;
    
}
img {
    height: 25px;
    margin-right: 15px;
}

.img-check {
    display: flex;
    align-items: center;
}

@keyframes img-anim {
    0%, 100% {scale: 1; }
    50% {scale: 1.1; }
}

.ul {padding-block: 10px;}

.ul div {  display: flex; }
.ul p { margin: 0; padding: 0;  }
.li-selecionado {  
    font-weight: bold; color:white; 
    background: var(--cor2);
    animation: img-anim 0.3s forwards;
    border-radius: 3px;
}
.li-nao-selecionado{
    color:black;
    background: white;
    border: 1px solid black;
    border-radius: 3px;
}

.mensagem-troco-errado {
    color: red;
}


</style>


<!-- 80400418 -->